import Icon from './Icon'

export default Icon
// eslint-disable-next-line import/export
export * from './Icon'
